import { createApp, h } from 'vue';
import store from './Store'
import FunnelQuiz from "./Components/FunnelQuiz";
import DialogContainer from "./Components/DialogContainer";

import { i18nVue } from 'laravel-vue-i18n'

/*
 * Bootstrap general laravel related code
 */
require('./bootstrap');

/*
 * Bootstrap VueJS 3 App
 */
function initializeQuiz(element)
{
    let quizId = (typeof element !== 'number') ? element.dataset.quizId : element;
    let appContainerSelector = `funnelquiz-${quizId}`;

    const el = document.getElementById(appContainerSelector);

    let app = createApp({
        render: () =>
            h(DialogContainer, {
                quizData: JSON.parse(el.dataset.quiz),
            }),
    });

    // Add dependencies & mount to element
    app.use(store)
       .use(i18nVue, {
            lang: 'en',
            resolve: lang => JSON.parse(el.dataset.trans),
       })
       .mount(`#${appContainerSelector}`);

    // Trigger an openDialog, on next tick, ensuring translations are loaded
    setTimeout(() => {
        store.commit('openDialog');
    }, 1);

}

let elements = document.getElementsByClassName('js-flitz-funnel-quiz');
for (let element of elements) {
        element.addEventListener("click", () => initializeQuiz(element));
}

// Make globally available
window.ffqInitialize = initializeQuiz;
